import { computed, defineComponent, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { EmergencyAction, EmergencyGetter } from '@/store/emergency/emergency.module';
import { Emergency } from '@/store/emergency/emergency.model';
import { EmergencyAnswerAction } from '@/store/emergencyAnswer/emergencyAnswer.module';
import EmergencyDetailCompoent from '@/components/emergencyDetail/EmergencyDetail.vue';

export default defineComponent({
  name: 'EmergencyDetailPage',
  components: {
    EmergencyDetailCompoent
  },
  setup: () => {
    const store = useStore();
    const route = useRoute();
    const emergencyId = computed<number>(() => parseInt(route.params.emergencyId as string));
    const emergency = computed<Emergency | undefined>(() => store.getters[EmergencyGetter.BY_ID](emergencyId.value));
    const provinceName = computed(() => (emergency.value?.province.name === 'กรุงเทพมหานคร')
      ? emergency.value?.province.name
      : `จังหวัด${emergency.value?.province.name}`);
    const icon = computed(() => (emergency.value?.emergencyType.id !== 1)
      ? (emergency.value?.emergencyType.id !== 2)
        ? 'fa-fist-raised'
        : 'fa-bolt'
      : 'fa-house-damage');
    const subtitle = computed(() => (emergency.value?.emergencyType.id !== 1)
      ? (emergency.value?.emergencyType.id !== 2)
        ? 'เหตุการณ์ร้องเรียน/ร้องทุกข์/ชุมนุมต่าง ๆ'
        : 'ปัญหาสำคัญเร่งด่วนต่าง ๆ'
      : 'สถานการณ์ภัยพิบัติต่าง ๆ');
    const isLoading = computed(() => store.getters[EmergencyGetter.STATUS] === 'init' || store.getters[EmergencyGetter.STATUS] === 'loading');

    onMounted(() => {
      store.dispatch(EmergencyAction.FIND, { id: emergencyId.value })
        .then(() => store.dispatch(EmergencyAnswerAction.FETCH, { emergencyId: emergencyId.value }));
    });

    return {
      emergency,
      provinceName,
      icon,
      subtitle,
      isLoading,
    };
  },
});
